import Keycloak from 'keycloak-js';
import { fetchQuery, graphql } from 'relay-runtime';

import { getAnonymousEnvironment } from './relay.js';
import {
  type keycloakQuery$data,
  type keycloakQuery,
} from './__generated__/keycloakQuery.graphql.js';

// eslint-disable-next-line @typescript-eslint/naming-convention
let _keycloak: Keycloak | null = null;

/**
 * Get organization details with a keycloak query
 */
export async function getOrganizationDetails(): Promise<
  keycloakQuery$data | undefined
> {
  return fetchQuery<keycloakQuery>(
    getAnonymousEnvironment(),
    graphql`
      query keycloakQuery {
        organization {
          sso {
            clientId
            realm
            url
          }
        }
      }
    `,
    {},
  ).toPromise();
}

/**
 * Get keycloak client
 */
export async function getKeycloakClient(): Promise<Keycloak> {
  if (_keycloak == null) {
    const data = await getOrganizationDetails();

    if (data?.organization == null) {
      throw new Error('Invalid organization');
    }

    const { clientId, realm, url } = data.organization.sso;

    _keycloak = new Keycloak({
      clientId,
      realm,
      url,
    });

    await _keycloak.init({
      adapter: 'default',
      // TODO: only in local
      // enableLogging: true,
      onLoad: 'login-required',
    });
  }

  return _keycloak;
}

/**
 * Logout user
 */
export async function logout(): Promise<void> {
  const keycloak = await getKeycloakClient();
  await keycloak.logout();
}
